import {makeStyles} from 'tss-react/mui';

export const usePtrnTablBaseStyle = makeStyles()((theme) => ({
   table: {tableLayout: 'fixed', backgroundColor: 'white'},
   thead: {
      backgroundColor: 'transparent'
   },
   tHeadCell: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main
   },
   tbodycell: {
      borderColor: theme.palette.grey[500],
      paddingTop: 4,
      paddingBottom: 4,
      paddingLeft: 8,
      paddingRight: 8
   },
   tCellFirst: {
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8
   },
   tCellLast: {
      borderTopRightRadius: 8,
      borderBottomRightRadius: 8
   }
}));

export class PtrnTablaBasePropsUtils {
   static getNroAccionesXFila(...accionesItem) {
      let nro = accionesItem.reduce<number>((prev, curr) => {
         if (Boolean(curr)) {
            prev++;
         }
         return prev;
      }, 0);
      return nro;
   }
   static getAccionCellWidth(nroAccionesXItem: number) {
      const widthPerButton = 48;
      const maxBotonesCell = 4;

      //si importar cuantas accionesAdicionalesRow, solo se aceptaran tener un maximo de 4 acciones visibles
      let nroBotonesCeldaAccion =
         nroAccionesXItem <= maxBotonesCell ? nroAccionesXItem : maxBotonesCell;

      const accionesWidth = widthPerButton * nroBotonesCeldaAccion;

      return accionesWidth;
   }
}
